import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://unxxifxttultyocmfmmf.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_RC1zno8gIwSZA57aezdYlQ_t4UdKFCG";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { persistSession: false },
  realtime: { params: { eventsPerSecond: 5 } },
});
